export default { sha: '6474d0b97d081a303dc3e7110f3d338c1f878ccb', buildNumber: 'undefined' }
